<template lang="pug">
.dwgmain
  #dwgbox(ref="dwgbox")
  application(ref="application" type="dwg" v-if="dwgloaded")

</template>
<script>
/**
 * 警告 ！！
 * 请不要格式化文档，本来可读性很强了，不要很简单的组件整好几十行 ！！！
 * 对应组件的功能写到对应组件上，不明白别乱写，搞得看不懂我找你 ！！！
 */
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import application from "@/CommonDP/mongeView/appView/applicationH5.vue";
import mongeCommon from "@/CommonDP/mongeView/common/mongeCommon";
import { mapState } from "vuex";

export default {
  components: {
    application
  },
  data () {
    return {
      dwgSpaceList: [], // 模型空间
      selDwgSpace: '',
      dwgloaded: false,
      questionId: '',
      checkContent: '',
      flowInstanceId: '',
      shareId: ''
    };
  },
  computed: {
    ...mapState({
      loginUserId: state => state.user.userId
    }),
    mlibEnabled() {
      return mongeApp.mlibEnabled;
    },
    userId() {
      return this.$route.query.userId || this.loginUserId;
    },
    dwgdata() {
      return JSON.parse(mongeApp.map.fileInfo);
    },
    spaceOfDwgData() {
      return mongeApp.map.spaceOfDwgData;
    },
    annotationData() {
      return mongeApp.map.annotationData;
    },
    annotationList() {
      return mongeApp.map.annotationList;
    },
    dicList() {
      return mongeApp.dicList;
    },
    hasList() {
      return mongeApp.hasList;
    },
    boxStyle() {
      return this.hasList ? { width: "calc(100% - 300px)" } : { width: "100%" };
    },
    // 状态字典
    statusList() {
      return this.dicList?.statusList || [];
    }
  },
  watch: {
    async hasList() {
      await this.$nextTick();
      mongeApiMlib.resize();
    },
    spaceOfDwgData(val, oldVal) {
      if (oldVal && val) {
        console.log("spaceOfDwgData", JSON.parse(val));
        this.setSpace(JSON.parse(val));
      }
    },
    $route: {
      async handler() {
        this.questionId = this.$route.query.questionId;
        this.checkContent = this.$route.query.checkContent;
        this.flowInstanceId = this.$route.query.flowInstanceId || '';
        this.shareId = this.$route.query.i || '';
        if (this.questionId) {
          if (this.questionId === "clear") {
            mongeApiMlib.clearAnnotation();
          } else {
            console.log("定位云线");
            await this.getDicList(this.flowInstanceId);
            await this.getAnnotationData(this.questionId, this.flowInstanceId, this.shareId);
          }
        }
        if (this.checkContent) {
          this.$toast("选择点位放置云线描述");
          mongeApiMlib.setMapText(this.checkContent);
        }
      },
      deep: true
    }
  },
  created () {
    this.getFileInfo();
  },
  beforeDestroy () {
    // 问题列表改变布局位置
    mongeMutations.setHasList(false);
    mongeMutations.openLegend(false);
    mongeMutations.setOverlayList();
  },
  methods: {
    // 获取文件信息
    async getFileInfo() {
      const { fileId = "", versionId: fileVersion = "", questionId = "", i = "", flowInstanceId } = this.$route.query;
      mongeMutations.setShareId(i);
      this.questionId = questionId;
      this.flowInstanceId = flowInstanceId || '';
      this.shareId = i || '';
      if (!fileId) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      const { data } = await mongeService.getFileDetails(fileId, i);
      const urlData = {
        fileId,
        fileName: encodeURIComponent(data.fileName),
        prjId: data.prjId,
        fileVersion,
        enterpriseId: data.enterpriseId
      };
      document.title = data.fileName;
      mongeMutations.setDwgData(JSON.stringify(urlData));
      await this.getDwgData();
    },
    // 获取引擎图纸url参数
    async getDwgData() {
      const dwgdatas = this.dwgdata;
      const fileID = dwgdatas.fileId;
      const fileVersion = dwgdatas.fileVersion || '';
      await this.queryConvertMode();
      try {
        // 启动新的模式
        if (this.mlibEnabled) {
          const res = await mongeService.queryModelLightFilesFromMLib(fileID, fileVersion);
          this.dwgSpaceList = await mongeApiMlib.dealMongeFiles(res.data || {});
          console.log("dwgSpaceList", this.dwgSpaceList);
          this.selDwgSpace = this.dwgSpaceList[0].fileName;// 空间名称
          mongeMutations.setSpaceOfDwgData(JSON.stringify(this.selDwgSpace));
          this.loadDwg(this.dwgSpaceList[0]);
        } else {
          const res = await mongeService.queryDwgSpace(fileID, fileVersion);
          this.dwgSpaceList = mongeApiMlib.assembleUrl(res.data).map(e => {
            return { index: e.id, fileName: e.picName, ...e };
          });
          this.selDwgSpace = this.dwgSpaceList[0].fileName;// 空间名称
          mongeMutations.setSpaceOfDwgData(JSON.stringify(this.selDwgSpace));
          this.loadDwg(this.dwgSpaceList[0].picsurl);
        }
      } catch (error) {
        console.debug(error);
        this.$error(error.message || "加载图纸错误");
      }
    },
    async queryConvertMode() {
      try {
        const res = await mongeService.queryConvertMode(this.dwgdata.fileId, this.dwgdata.fileVersion || '');
        mongeMutations.changeMlibEnabled(!!(res.data && res.data === 1));
      } catch (e) {
        mongeMutations.changeMlibEnabled(false);
      }
      return Promise.resolve();
    },
    /**
   * 入口
   * @param { 当前空间的url } dwgdata
   */
    async loadDwg(picsurl) {
      await mongeApiMlib.loadDwg(picsurl, "dwgbox", true);
      this.dwgloaded = true;
      if (this.questionId) { // 定位云线
        await this.getDicList(this.flowInstanceId);
        await this.getAnnotationData(this.questionId, this.flowInstanceId, this.shareId);
      }
    },
    // 定位时、空间不同
    async setSpace(val) {
      this.selDwgSpace = val;
      let url = '';
      if (this.mlibEnabled) {
        url = this.dwgSpaceList.find(e => e.fileName === val);
      } else {
        const data = this.dwgSpaceList.find(e => e.picName === val);
        url = data.picsurl;
      }
      await mongeApiMlib.loadMap(url, "dwgbox", true);
      this.dwgloaded = true;
      await this.$nextTick();
      mongeApiMlib.resize();
      if (this.questionId) { // 定位云线
        mongeCommon.fitToQs(this.annotationData, this.statusList, "dwg");
      }
    },
    // 空间切换
    async changespace(val) {
      mongeMutations.setSpaceOfDwgData(JSON.stringify(val));
    },
    async getDicList(flowInstanceId) {
      mongeCommon.getDicList(this.dwgdata.prjId, flowInstanceId);
    },
    async getAnnotationData(val, flowInstanceId, shareId) {
      mongeCommon.getNotationData(val, this.userId, "dwg", flowInstanceId, shareId);
    }
  }
};
</script>

<style lang="scss" scoped>
.dwgmain{
  width: 100vw;
  height: 100%;
  position: relative;
  overflow: hidden;
  #dwgbox {
    position: absolute;
    width: 100vw;
    height: 100%;
  }
  // .loadStyle{
  //   top: 46px;
  //   height: calc(100% - 46px);
  // }
}
</style>
